<template>
  <div class="row">
    <div class="col-12 col-lg-4">
        <div class="card card-body">
            <h1 class="text-primary">
                {{ stats.status_1 }}
            </h1>
            <h5>
                <i class="fa fa-check"></i>
                الفواتير الصالحة
            </h5>
        </div>
    </div>
    <div class="col-12 col-lg-4">
        <div class="card card-body">
            <h1 class="text-danger">
                {{ stats.status_2 }}
            </h1>
            <h5>
                <i class="fa fa-times"></i>
                الفواتير الغير الصالحة
            </h5>
        </div>
    </div>
    <div class="col-12 col-lg-4">
        <div class="card card-body">
            <h1 style="color: #F25912">
                {{ stats.status_0 }}
            </h1>
            <h5>
                <i class="fa fa-clock-o"></i>
                طلبات في الإنتظار
            </h5>
        </div>
    </div>
    <div class="col-12 col-lg-4">
        <div class="card card-body">
            <h1 style="color: #4E61D3">
                {{ stats.devices }}
            </h1>
            <h5>
                <i class="fa fa-server"></i>
                الأجهزة المضافة
            </h5>
        </div>
    </div>
    <div class="col-12 col-lg-4">
        <div class="card card-body">
            <h1 style="color: #34656D">
                {{ stats.refund }}
            </h1>
            <h5>
                <i class="fa fa-refresh"></i>
                الفواتير المسترجعة
            </h5>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            stats: {}
        }
    },
    created(){
        var g = this;
        $.post(api + '/user/web/stats', {
            jwt: this.user.jwt
        }).then(function(r){
            g.stats = r.response
        })
    }
}
</script>

<style>

</style>